<template>
  <div class="infoBlock">
    <div class="textWithButton">
      <div
        class="label"
        data-automation="package-sysreq-label"
      >
        Install System Prerequisites for {{ selectedOS.display }}<a
          class="changeOSLink"
          data-automation="package-sysreqs-change-os"
          href=""
          @click.prevent="handleChangeOS"
        >change</a>
      </div>
      <div>
        <div class="actionBar inline">
          <ActionButton
            :button-class="infoClass"
            data-automation="package-sysreqs-info"
            label="info"
            @doIt="toggleShowInfo"
          />
        </div>
        <button
          v-if="haveInstructions && !gettingSystemDependencies"
          class="copyButton"
          data-automation="package-sysreqs-copy"
          data-clipboard-target="#sysInstallInstructions"
        >
          Copy
        </button>
      </div>
    </div>

    <div
      v-if="showInfo"
      data-automation="package-sysreqs-infodetail"
      class="toggleableInfo"
    >
      <p>
        Known system prerequisites are automatically detected from the package's
        system requirements information.
        The <a
          data-automation="package-sysreqs-link"
          :href="docURL"
          target="_blank"
        >admin guide</a>
        provides additional information on system dependency detection, limitations,
        or how to report missing information.
      </p>
    </div>

    <GettingMore
      :show="gettingSystemDependencies"
      label="Getting system prerequisites"
    />
    <pre v-if="haveInstructions && !gettingSystemDependencies"><code
id="sysInstallInstructions"
                                                                     data-automation="package-sysreqs-cmd"
    >{{ instructions.join('\n') }}</code></pre>
    <div
      v-if="!haveInstructions && !gettingSystemDependencies"
      class="toggleableInfo"
    >
      <p>No known prerequisites</p>
    </div>

    <ChangeOSDialog
      v-if="showChangeOSDialog"
      @closeDialog="closeChangeOSDialogDialog"
    />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import GettingMore from './GettingMore'
import { serverPath } from '../api/http-common'
import ActionButton from './ActionButton'
import ChangeOSDialog from './dialogs/ChangeOSDialog'

export default {
  name: 'PackageSystemDependencies',
  components: {
    GettingMore,
    ActionButton,
    ChangeOSDialog,
  },
  props: {
    repoId: {
      type: Number,
      required: true,
    },
    selectedPackage: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      showInfo: false,
      showChangeOSDialog: false,
    }
  },
  computed: {
    ...mapState({
      selectedOS: state => state.packages.selectedOS,
      gettingSystemDependencies: state => state.packages.gettingSystemDependencies,
    }),
    instructions: function () {
      return this.selectedPackage && this.selectedPackage.systemInstallInstructions
    },
    haveInstructions: function () {
      return this.instructions && this.instructions.length > 0
    },
    infoClass: function () {
      return this.showInfo ? 'toggleInfo current' : 'toggleInfo'
    },
    docURL: function () {
      return `${serverPath()}__docs__/admin/appendix/system-dependency-detection/`
    },
  },
  watch: {
    selectedPackage: function (newValue, oldValue) {
      if (newValue.id !== oldValue.id) {
        this.getPackageSystemDependencies({ repoId: this.repoId, pkg: this.selectedPackage, os: this.selectedOS })
      }
    },
    selectedOS: function (newValue, oldValue) {
      this.getPackageSystemDependencies({ repoId: this.repoId, pkg: this.selectedPackage, os: this.selectedOS })
    },
  },
  created: function () {
    this.getPackageSystemDependencies({ repoId: this.repoId, pkg: this.selectedPackage, os: this.selectedOS })
  },
  methods: {
    ...mapActions([
      'getPackageSystemDependencies',
    ]),
    toggleShowInfo: function () {
      this.showInfo = !this.showInfo
    },
    handleChangeOS: function () {
      this.showChangeOSDialog = true
    },
    closeChangeOSDialogDialog: function () {
      this.showChangeOSDialog = false
    },
  },
}

</script>

<style scoped>
  .changeOSLink {
    font-size: 12px;
    font-weight: normal;
    text-transform: none;
    margin-left: 15px;
  }
</style>
